export enum MenuRoutePaths {
  DASHBOARD = "/dashboards/default",
  SITES = "/sites/index",
  USERS = "/users",
  PROFILE = "/profile",
  DEVICES = "/devices/index",
  REPORTS = "/reports",
  ISSUES = "/devices/issues",
}

export enum AuthRoutePaths {
  SIGN_IN = "/auth/sign-in",
  SIGN_UP = "/auth/sign-up/default",
  FORGOT_PASSWORD = "/auth/forgot-password",
}
